import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'customer-app-equity-chapter-icon',
  templateUrl: './equity-chapter-icon.component.html',
  styleUrls: ['./equity-chapter-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle]
})
export class EquityChapterIconComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly chapter = input<any>(undefined);
  readonly contrast = input<boolean>(undefined);
  readonly active = input<boolean>(undefined);
  readonly noMargin = input<boolean>(undefined);
  readonly chapterLink = input<boolean>(undefined);
  readonly simple = input<boolean>(undefined);

  get iconUrl(): string {
    return `assets/equity/icons/progress-bar/${this.chapter()?.icon}.svg`;
  }

  goToChapter(id: string): void {
    document.getElementById(id).scrollIntoView();
  }
}
